/**
 * Utility functions for fund name display and formatting
 */

/**
 * Helper function to get a display name for a fund with multiple fallbacks
 * @param fund The fund object which may contain name in various formats
 * @returns A human-readable fund name string
 */
export const getFundDisplayName = (fund: any) => {
  if (!fund) return 'this fund';

  // First priority: Check for the display_name field we explicitly added
  if (fund.display_name && typeof fund.display_name === 'string' && fund.display_name.trim()) {
    return fund.display_name.trim();
  }
  
  // Second priority: Check the name field from company funds table
  if (fund.name && typeof fund.name === 'string' && fund.name.trim()) {
    return fund.name.trim();
  }
  
  // Try the fund_name field which is commonly populated
  if (fund.fund_name && typeof fund.fund_name === 'string' && fund.fund_name.trim()) {
    return fund.fund_name.trim();
  }
  
  // Try other standard field names
  if (fund.full_name && typeof fund.full_name === 'string' && fund.full_name.trim()) {
    return fund.full_name.trim();
  }
  
  if (fund.fundName && typeof fund.fundName === 'string' && fund.fundName.trim()) {
    return fund.fundName.trim();
  }
  
  // Try to construct a name from fund and company codes
  const codeParts = [];
  if (fund.management_company_code) codeParts.push(fund.management_company_code);
  if (fund.fund_code) codeParts.push(fund.fund_code);
  if (codeParts.length > 0) {
    return codeParts.join(' ');
  }
  
  // Last fallback
  return 'this fund';
};
